<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="grid_custom mt-6">
        <v-card class="list_menu_content mt-3" v-if="manage_count_stock == true">
          <router-link to="/stock/stockhistory" class="menu_card_content d-flex flex-column justify-center align-center" >
            <div class="img_menu_content">
              <img src="@/assets/count_stock.png">
            </div>
            <div class="title_menu_content">
              นับสต๊อกคลังหลัก<br>(Count the main inventory stock)
            </div>
          </router-link>
        </v-card>
        <v-card class="list_menu_content mt-3" v-if="manage_count_stock_store == true">
          <router-link to="/stock/storecountstock" class="menu_card_content d-flex flex-column justify-center align-center">
            <div class="img_menu_content">
              <img src="@/assets/store_stock.png">
            </div>
            <div class="title_menu_content">
              นับสต๊อกร้านค้า<br>(Store stock count)
            </div>
          </router-link>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios"
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "CountStockMenu",
  data() {
    return {
      loading_page: false,
      manage_stock: null,
      manage_count_stock: null,
      manage_count_stock_store: null,
    }
  },
  methods: {
    async get_data() {
      if(this.$store.state.access_token !== null) {
        let config = {
          headers: {
            // 'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${this.$store.state.token}`
          }
        };
        HTTP.get('/v1/admin/get/permission' , config)
        .then((res) => {
          if(res.data.successful === true) {
            this.manage_stock = res.data.data.manage_stock
            this.manage_count_stock = res.data.data.manage_count_stock
            this.manage_count_stock_store = res.data.data.manage_count_stock_store
            
            if(this.manage_stock == false) {
              this.$router.push('/profile_emp')
            }
          }
        })
      }
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_custom {
  display: grid;
  grid-template-columns: 50% 50%;
}
.list_menu_content {
  width: 97%;
}
.router-link-active,
.list_menu_content:hover>.menu_card_content {
  color: #fff !important;
  background-image: linear-gradient(to right, #A3802E, #c1a75b, #c1a25f) !important;
  height: 100%;
}

.menu_card_content {
  padding: 15px;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87) !important;
  height: 100%;
}

.img_menu_content {
  width: 100px;
}

.img_menu_content>img {
  max-width: 100%;
}

.title_menu_content {
  font-size: 20px;
  text-align: center;
}
@media only screen and (max-width: 500px) {
  .grid_custom {
    display: grid;
    grid-template-columns: 100%;
  }
  .list_menu_content {
    width: 100%;
  }
}
</style>
